<div class="layout-wrapper">

  <div class="sidebar" [class.mobile-hidden]="isMobileView && !sidebarOpen">

    <div class="sidebar-header">
      <div class="logo">
        <div class="logo-icon">AL</div>
        <span class="logo-text">ALUGULOO</span>
      </div>
      <div class="date">{{ today | date: 'fullDate' }}</div>
    </div>

    <div class="user-info">
      <div class="user-avatar"></div>
      <span class="user-name">{{ currentusername }}</span>
    </div>

    <!-- Subscription Card -->
    <div class="plan-card" *ngIf="sidebarPlan && !planLoading" [style.--plan-color]="sidebarPlan.color">
      <div class="plan-card-stripe"></div>

      <div class="plan-card-header">
        <span class="plan-card-name">{{ sidebarPlan.name | uppercase }}</span>
        <i class="fa-solid fa-crown plan-card-crown"></i>
      </div>

      <p class="plan-card-desc">{{ sidebarPlan.tagline }}</p>

      <div class="plan-card-status">
        <span class="status-dot" [class.active]="sidebarPlan.marketplaceEnabled"
          [class.inactive]="!sidebarPlan.marketplaceEnabled">
        </span>
        <span class="status-label">
          {{ sidebarPlan.marketplaceEnabled ? 'Marketplace active' : 'Marketplace inactive' }}
        </span>
      </div>

      <ng-container *ngIf="sidebarPlan.marketplaceEnabled">
        <div class="plan-listings-row">
          <span class="listings-label">Listings</span>
          <span class="listings-count">
            {{ sidebarPlan.activeListings }} / {{ sidebarPlan.activeListingLimit }}
          </span>
        </div>
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="sidebarPlan.listingPercent"></div>
        </div>
      </ng-container>

      <div class="plan-renewal" *ngIf="sidebarPlan.renewalDate">
        <i class="fa-regular fa-calendar"></i>
        <span>Renews {{ sidebarPlan.renewalDate | date: 'd MMM y' }}</span>
      </div>

      <button class="plan-manage-btn" (click)="navigateToManagePlan()">
        Manage plan
        <i class="fa-solid fa-arrow-right"></i>
      </button>
    </div>

    <!-- Skeleton -->
    <div class="plan-card-skeleton" *ngIf="planLoading">
      <div class="skel skel-title"></div>
      <div class="skel skel-desc"></div>
      <div class="skel skel-bar"></div>
      <div class="skel skel-btn"></div>
    </div>

    <nav class="sidebar-nav">
      <div class="nav-item" *ngFor="let item of menuItems" [class.active]="item.active" (click)="navigateTo(item)">
        <i class="nav-icon" [innerHTML]="item.icon"></i>
        <span class="nav-label">{{ item.label | translate }}</span>
        <span class="nav-badge" *ngIf="item.badge">{{ item.badge }}</span>
      </div>
    </nav>

  </div>

  <div class="main-area">
    <header class="topbar">
      <div class="left-section">
        <span class="user-name2">Hello {{ currentusername }}</span>
        <div class="date">{{ today | date: 'fullDate' }}</div>
      </div>
      <div class="right-section">
        <select (change)="ChangeLang($event)">
          <option [selected]="lang === 'en'" value="en">English</option>
          <option [selected]="lang === 'ar'" value="ar">
            {{ 'ARABIC' | translate }}
          </option>
        </select>

        <button mat-icon-button [matMenuTriggerFor]="userAccountMenu">
          <mat-icon>account_circle</mat-icon>
        </button>

        <mat-menu #userAccountMenu>
          <app-profilecard *ngIf="currentuid" [uid]="currentuid" [planName]="planBadgeName"
            [planColor]="planBadgeColor">
          </app-profilecard>
        </mat-menu>
      </div>
    </header>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>